import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewGraficoConsumoCorral = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'mapa_actividad',
        name: 'Presentacion de Actividad Mapa',
        component: ViewGraficoConsumoCorral,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router